const jpegRanges = [
    [151700000000000, 151705000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [151835000000000, 151840000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [152060000000000, 152065000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [152205000000000, 152210000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [153895000000000, 153900000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [154535000000000, 154540000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [157555000000000, 157560000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [161715000000000, 161720000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [162060000000000, 162065000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
    [164760000000000, 164765000000000], // 298a46fdf18f2096f822577b9661232d4cefba084925eb746939723647f8d18d
]

export function isJpeg(num) {
    return jpegRanges.some(([start, end]) => num >= start && num <= end);
}